import { useState } from "react";
import {CURRENCIES} from "../curify/constants";

const CurifyClient = require("../curify/client");

function App() {
  const [publicKey, setPublicKey] = useState("pk_live_RtwV5vApVGJbtY4EpBXakm");
  const [reference, setReference] = useState(
    Math.floor(Math.random() * 10000000)
  );
  const [firstName, setFirstName] = useState("John");
  const [lastName, setLastName] = useState("Smith");
  const [email, setEmail] = useState("john.smith@example.com");
  const [phone, setPhone] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  const [amount, setAmount] = useState(Math.floor(Math.random() * 1000));
  const [currency, setCurrency] = useState("USD");

  const [cardNumber, setCardNumber] = useState("4539225011794489");
  const [expiryMonth, setExpiryMonth] = useState("12");
  const [expiryYear, setExpiryYear] = useState("30");
  const [cvv, setCVV] = useState("999");
  const [countryCode, setCountryCode] = useState("US");
  const [merchantInitiated, setMerchantInitiated] = useState(false);

  const [events, setEvents] = useState([]);

  const processPayment = async () => {
    const client = new CurifyClient(publicKey);

    setIsLoading(true);
    setEvents([])
    try {
      const result = await client.curePayment(
        amount,
        currency,
        {
          name: "Global Payments",
          error_code: "General Decline",
          payment_method_type: "card",
          payment_method_metadata: {
            status: "failed",
          },
        },
        reference,
        {
          shipping_address: { country_code: countryCode },
          billing_address: { country_code: countryCode },
          first_name: firstName,
          last_name: lastName,
          email: email,
          phone: phone,
        },
        {
          card_number: cardNumber,
          expiry_month: expiryMonth,
          expiry_year: expiryYear,
          cvv: cvv,
        },
        merchantInitiated,
        (events) => {
          setEvents([ ...events ])
        }
      );
    } catch (error) {
      setReference(Math.floor(Math.random() * 10000000));
      if (error.response?.data?.status === "failed") {
        // alert(
        //   "Failed to cure payment across all applicable processors, please try another card"
        // );
        return;
      }
      alert("Oops: " + JSON.stringify(error.response?.data || {}));
    } finally {
      setIsLoading(false);
    }
  };

  const renderCards = () => {
    return (
      <>
        <div className="mw-325px">
          <h3>Test Payment Portal</h3>
          <p className="mb-0">
            To test the payment, please fill in the required details on the
            right side
          </p>
        </div>
        <div className="alert alert-light">
          <b>Bogus Gateway</b>
          <table className="table table-borderless text-start fs-6 fw-medium mb-3">
            <tbody>
              <tr>
                <td>Success:</td>
                <td>4242424242424242</td>
              </tr>
              <tr>
                <td>Failure:</td>
                <td>4000000000000002</td>
              </tr>
            </tbody>
          </table>

          <b>Maverick Payments</b>
          <table className="table table-borderless text-start fs-6 fw-medium mb-3">
            <tbody>
              <tr>
                <td>Success:</td>
                <td>4539225011794489</td>
              </tr>
              <tr>
                <td>Failure:</td>
                <td>4000000000000002</td>
              </tr>
            </tbody>
          </table>

          {/*<b>NMI</b>*/}
          {/*<table className="table table-borderless text-start fs-6 fw-medium mb-3">*/}
          {/*  <tbody>*/}
          {/*  <tr>*/}
          {/*    <td>Success:</td>*/}
          {/*    <td>5411111111111115</td>*/}
          {/*  </tr>*/}
          {/*  <tr>*/}
          {/*    <td>Failure:</td>*/}
          {/*    <td>4000120000001154</td>*/}
          {/*  </tr>*/}
          {/*  </tbody>*/}
          {/*</table>*/}

          {/*<b>Global Payments</b>*/}
          {/*<table className="table table-borderless text-start fs-6 fw-medium mb-3">*/}
          {/*  <tbody>*/}
          {/*  <tr>*/}
          {/*    <td>Success:</td>*/}
          {/*    <td>4263970000005262</td>*/}
          {/*  </tr>*/}
          {/*  <tr>*/}
          {/*    <td>Failure:</td>*/}
          {/*    <td>4000120000001154</td>*/}
          {/*  </tr>*/}
          {/*  </tbody>*/}
          {/*</table>*/}

          <b>Stripe</b>
          <table className="table table-borderless text-start fs-6 fw-medium mb-0">
            <tbody>
              <tr>
                <td>Success:</td>
                <td>4242424242424242</td>
              </tr>
              <tr>
                <td>Failure:</td>
                <td>4000000000000002</td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    )
  }

  const renderEvents = () => {
    return events.map((event, i) => {

      if (event._type === "payment_instrument") {
        return (
          <div className="alert alert-info mb-0 text-start w-100">
            <h6>Payment Instrument</h6>
            <div>Payment instrument created successfully</div>
            <div>Next Action: Create Payment Intent</div>
          </div>
        )
      }
      if (event._type === "payment_intent") {
        return (
          <div className="alert alert-light mb-0 text-start w-100">
            <h6>Payment Intent</h6>
            <div>Payment intent created successfully</div>
            <div>Next Action: Payment Attempt</div>
          </div>
        )
      }
      if(event.status === "completed"){
        return (
          <div className="alert alert-success mb-0 text-start">
            <h6>Payment Cured!</h6>
            <div>Status: Success</div>
            <div>Next Action: Notify Merchant of payment success</div>
          </div>
        )
      }else if(event.status === "failed"){
        return (
          <div className="alert alert-danger mb-0 text-start">
            <h6>Payment Failed</h6>
            <div>Status: Failed</div>
            <div>Next Action: None, no applicable processors to retry payment on</div>
          </div>
        )
      }

      return null
    })
  }

  return (
    <div className="page demo">
      <div className="onboarding">
        <div className="onb-aside w-100">
          <div class="t-section">
            <a href="javascript:void(0)">
              <img alt="Logo" src="logo.png" className="h-40px"/>
            </a>
            {(!isLoading && events.length === 0) && renderCards()}
            {renderEvents()}
            {isLoading && (
              <>
                <div className="alert mb-0">
                  <h6>Loading...</h6>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="onb-body">
          <div className={"form"}>
            {/* Starts: Merchant Details */}
            <div className={"s-card"}>
              <label className="form-label">Merchant</label>
              {/* Starts: Merchant Public Key */}
              <div className="form-group">
                <label className="form-label fw-normal">
                  Merchant Public Key*
                </label>
                <input
                  className="form-control"
                  placeholder="Merchant Public Key"
                  value={publicKey}
                  onChange={(e) => setPublicKey(e.target.value || null)}
                />
                <div className="form-text">
                  Defines the Merchant the transaction is processed on behalf
                  of.
                </div>
              </div>
              {/* end: Merchant Public Key */}
              {/* Starts: Merchant Reference */}
              <div className="form-group">
                <label className="form-label fw-normal">
                  Merchant Reference*
                </label>
                <input
                  className="form-control"
                  placeholder="Merchant Reference"
                  value={reference}
                  onChange={(e) => setReference(e.target.value || null)}
                />
                <div className="form-text">
                  Merchant's reference for the payment.
                </div>
              </div>
              {/* end: Merchant Reference */}
              {/* Starts: Amount,Currency  */}
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label className="form-label fw-normal">Amount*</label>
                    <input
                      className="form-control"
                      placeholder="Amount"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value || null)}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <label className="form-label fw-normal">Currency*</label>
                    <select
                      className="form-control form-select"
                      value={currency}
                      onChange={(e) => setCurrency(e.target.value)}
                    >
                      {CURRENCIES.map((code) => (
                        <option key={code} value={code}>{code}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              {/* end: Amount,Currency */}
            </div>
            {/* End: Merchant Details */}

            {/* Starts: Card Details */}
            <div className={"s-card"}>
              <label className="form-label">Card Details</label>
              {/* Starts: Card Number* */}
              <div className="form-group">
                <label className="form-label fw-normal">Card Number*</label>
                <input
                  className="form-control"
                  placeholder="Card Number"
                  value={cardNumber}
                  onChange={(e) => setCardNumber(e.target.value || null)}
                />
              </div>
              {/* end: Card Number* */}
              {/* Starts: Month, Year, CVV */}
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label className="form-label fw-normal">Exp Month*</label>
                    <select
                      className="form-control"
                      value={expiryMonth}
                      onChange={(e) => setExpiryMonth(e.target.value || null)}
                    >
                      <option value={"01"}>01</option>
                      <option value={"02"}>02</option>
                      <option value={"03"}>03</option>
                      <option value={"04"}>04</option>
                      <option value={"05"}>05</option>
                      <option value={"06"}>06</option>
                      <option value={"07"}>07</option>
                      <option value={"08"}>08</option>
                      <option value={"09"}>09</option>
                      <option value={"10"}>10</option>
                      <option value={"11"}>11</option>
                      <option value={"12"}>12</option>
                    </select>
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <label className="form-label fw-normal">Exp Year*</label>
                    <select
                      className="form-control"
                      value={expiryYear}
                      onChange={(e) => setExpiryYear(e.target.value || null)}
                    >
                      <option value={"25"}>2025</option>
                      <option value={"26"}>2026</option>
                      <option value={"27"}>2027</option>
                      <option value={"28"}>2028</option>
                      <option value={"29"}>2029</option>
                      <option value={"30"}>2030</option>
                    </select>
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <label className="form-label fw-normal">CVV*</label>
                    <input
                      className="form-control"
                      value={cvv}
                      onChange={(e) => setCVV(e.target.value || null)}
                    />
                  </div>
                </div>
              </div>
              {/* end: Month, Year, CVV */}
            </div>
            {/* End: Card Details */}

            {/* Starts: Customer Details */}
            <div className={"s-card"}>
              <label className="form-label">Customer Details</label>
              {/* Starts: First and Last Names */}
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label className="form-label fw-normal">First Name</label>
                    <input
                      className="form-control"
                      placeholder="first_name"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value || null)}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <label className="form-label fw-normal">Last Name</label>
                    <input
                      className="form-control"
                      placeholder="last_name"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value || null)}
                    />
                  </div>
                </div>
              </div>
              {/* end: First and Last Names */}
              {/* Starts: Email and Phone */}
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label className="form-label fw-normal">Email</label>
                    <input
                      className="form-control"
                      placeholder="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value || null)}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <label className="form-label fw-normal">Phone</label>
                    <input
                      className="form-control"
                      placeholder="phone"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value || null)}
                    />
                  </div>
                </div>
              </div>
              {/* end: Email and Phone */}
            </div>
            {/* End: Customer Details */}
            {/* Starts: MIT Details */}
            <div className={"s-card"}>
              <label className="form-label">Transaction Type</label>
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <select
                      className="form-control"
                      value={merchantInitiated}
                      onChange={(e) => setMerchantInitiated(e.target.value)}
                    >
                      <option value={false}>Customer Initiated</option>
                      <option value={true}>Merchant Initiated</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            {/* End: MIT Details */}
            <div className="gap"></div>
            <button
              className="btn btn-primary w-100"
              type="submit"
              disabled={isLoading}
              onClick={processPayment}
            >
              {isLoading ? "Loading..." : "Submit"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
